/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useState} from 'react'
import {Loading} from '../../../../../../../../../components/Loadings/loading'

const StepModal = ({data, hasError, formik}: any) => {
  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        <div style={{display: 'flex', gap: '1rem'}}>
          <div style={{display: 'flex', gap: '1rem', width: '100%'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>E-mail</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Digite um e-mail para unidade(filial)'
              ></i>
            </label>
            <div style={{flex: '1'}}>
              <input
                type='email'
                className='form-control form-control-lg form-control-solid'
                name='email'
                placeholder='name@example.com'
                value={formik.values.email}
                onChange={formik.handleChange('email')}
              />
              {!formik.values.email && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    O e-mail é obrigatório!
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export {StepModal}
